import { getDocument, setDocument, updateDocument } from './firestore.service'

const BUSINESS_SETTINGS_COLLECTION = 'businessSettings'
const BUSINESS_SETTINGS_DOC_ID = 'main'

const getDefaultBusinessSettings = () => ({
  active: {
    rubro: 'muebles',
    subrubro: null,
    designId: 'muebles/v1'
  },
  rubros: {
    muebles: {
      enabled: true,
      designs: ['muebles/v1'],
      defaultDesignId: 'muebles/v1'
    },
    indumentaria: {
      enabled: true,
      subrubros: {
        femenina: {
          enabled: true,
          designs: ['indumentaria/femenina/v1'],
          defaultDesignId: 'indumentaria/femenina/v1'
        },
        masculina: {
          enabled: false,
          designs: [],
          defaultDesignId: null
        },
        mixta: {
          enabled: false,
          designs: [],
          defaultDesignId: null
        }
      }
    },
    electrodomesticos: {
      enabled: false,
      designs: [],
      defaultDesignId: null
    },
    tecnologia: {
      enabled: false,
      designs: [],
      defaultDesignId: null
    }
  },
  updatedAt: new Date()
})

export const getBusinessSettings = async () => {
  try {
    const settings = await getDocument(BUSINESS_SETTINGS_COLLECTION, BUSINESS_SETTINGS_DOC_ID)
    if (!settings) {
      return getDefaultBusinessSettings()
    }

    const merged = {
      ...getDefaultBusinessSettings(),
      ...settings
    }

    return merged
  } catch (error) {
    console.error('Error obteniendo configuración comercial:', error)
    return getDefaultBusinessSettings()
  }
}

export const saveBusinessSettings = async (settings) => {
  try {
    const existing = await getDocument(BUSINESS_SETTINGS_COLLECTION, BUSINESS_SETTINGS_DOC_ID)

    const data = {
      ...settings,
      updatedAt: new Date()
    }

    if (existing) {
      await updateDocument(BUSINESS_SETTINGS_COLLECTION, BUSINESS_SETTINGS_DOC_ID, data)
      return
    }

    await setDocument(
      BUSINESS_SETTINGS_COLLECTION,
      BUSINESS_SETTINGS_DOC_ID,
      {
        ...data,
        createdAt: new Date()
      },
      { merge: true }
    )
  } catch (error) {
    console.error('Error guardando configuración comercial:', error)
    throw error
  }
}

export default {
  getBusinessSettings,
  saveBusinessSettings
}
